import { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * Hook personalizado para gerenciar o título dinâmico da página
 * Atualiza o document.title baseado nas configurações carregadas do servidor
 * 
 * @param {string} pageTitle
 * @param {string} format
 * @returns {string}
 */
function useDynamicTitle(pageTitle = '', format = '{razaoSocial} | {titulo}') {
  const configuration = useSelector(state => state.configuration);
  const { RazaoSocial, titulo } = configuration;

  useEffect(() => {
    // Só atualiza o título se temos os dados carregados
    if (RazaoSocial && titulo) {
      let dynamicTitle = format
        .replace('{razaoSocial}', RazaoSocial)
        .replace('{titulo}', titulo)
        .replace('{pageTitle}', pageTitle);

      // Remove espaços extras e separadores desnecessários
      dynamicTitle = dynamicTitle
        .replace(/\s+\|\s+$/g, '') // Remove " | " no final
        .replace(/^\s+\|\s+/g, '') // Remove " | " no início
        .replace(/\s+/g, ' ')      // Remove espaços duplos
        .trim();

      document.title = dynamicTitle;
    }
  }, [RazaoSocial, titulo, pageTitle, format]);

  // Retorna o título atual para uso no componente se necessário
  const currentTitle = RazaoSocial && titulo 
    ? format
        .replace('{razaoSocial}', RazaoSocial)
        .replace('{titulo}', titulo)
        .replace('{pageTitle}', pageTitle)
        .replace(/\s+\|\s+$/g, '')
        .replace(/^\s+\|\s+/g, '')
        .replace(/\s+/g, ' ')
        .trim()
    : document.title;

  return currentTitle;
}

export default useDynamicTitle;
